// FAQAccordion.jsx - Objection Handling Only (5-7 questions, no pricing)
import React, { useState } from 'react';
import './FAQAccordion.css';
import landingData from '../data/landingData.json';

const FAQAccordion = () => {
  const [openIndex, setOpenIndex] = useState(null);
  const { faqs } = landingData;

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="landing-section faq-section">
      <h2 className="section-title">Frequently asked</h2>
      
      <div className="faq-list">
        {faqs.map((faq, index) => (
          <div 
            key={index} 
            className={`faq-item ${openIndex === index ? 'open' : ''}`}
          >
            <button className="faq-question" onClick={() => toggleFAQ(index)}>
              <span>{faq.question}</span>
              <svg 
                className="faq-chevron" 
                width="20" 
                height="20" 
                viewBox="0 0 24 24" 
                fill="none" 
                stroke="currentColor" 
                strokeWidth="2"
              >
                <path d="m6 9 6 6 6-6" />
              </svg>
            </button>
            <div className="faq-answer">
              <p>{faq.answer}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default FAQAccordion;
